<script lang="ts">
	import { Button } from '@atoms';
	import type { LinkType } from '@queries/Link';
	import type { Snippet } from 'svelte';
	import type { HTMLButtonAttributes } from 'svelte/elements';

	type Variants = 'primary' | 'link' | 'outline';

	let {
		link,
		target,
		...rest
	}: {
		link: LinkType;
		variant?: Variants;
		href?: string;
		target?: string;
		children?: Snippet;
	} & HTMLButtonAttributes = $props();

	let href = $state('');
	if (link.slug) {
		href = `${link.slug}`;
	} else if (link.url) {
		href = link.url;
		if (!target && link.url.includes('http')) {
			//default to open in new tab
			target = '_blank';
		}
	} else if (link.email) {
		href = `mailto:${link.email}`;
	} else if (link.document) {
		href = link.document.url ?? '';
		if (!target) {
			//default to open in new tab
			target = '_blank';
		}
	}
</script>

<Button {target} {href} {...rest}>{link.title}</Button>
